import { api } from "./api";
import { config } from "../../config/environment";
import type { CustomRequestConfig } from "../../types/api";
import type {
  ILoginCredentials,
  IAuthResponse,
  IAuthUser,
  IRegisterCredentialsBase,
  IRegisterCredentials,
} from "../../types/auth";

const CLINIC_ID = config.clinic.id;

export const authApi = {
  // Public endpoints
  async login(credentials: ILoginCredentials): Promise<IAuthResponse> {
    const response = await api.post<IAuthResponse>("/auth/login", credentials);
    return response.data;
  },

  async register(userData: IRegisterCredentialsBase): Promise<IAuthResponse> {
    const userDataWithClinic: IRegisterCredentials = {
      ...userData,
      clinicId: CLINIC_ID,
    };
    const response = await api.post<IAuthResponse>(
      "/auth/register",
      userDataWithClinic
    );
    return response.data;
  },

  // Protected endpoints
  async validateToken(): Promise<IAuthUser> {
    const config: CustomRequestConfig = {
      requireAuth: true,
    };
    const response = await api.get<IAuthUser>("/auth/validate", config);
    return response.data;
  },

  async getCurrentUser(config: CustomRequestConfig): Promise<IAuthUser> {
    const response = await api.get<IAuthUser>("/auth/me", config);
    return response.data;
  },
};
